import React, { useEffect, useState } from "react";
import "../style/VISalesAgent.css";

const VISalesAgent = () => {
  const [iframeHeight, setIframeHeight] = useState("100vh");

  useEffect(() => {
    // Set page title
    document.title = "VI Sales Agent - ModalX";

    // Adjust iframe height based on viewport
    const updateHeight = () => {
      const viewportHeight = window.innerHeight;
      setIframeHeight(`${viewportHeight}px`);
    };

    updateHeight();
    window.addEventListener("resize", updateHeight);

    return () => {
      window.removeEventListener("resize", updateHeight);
      // Reset title when component unmounts
      document.title = "ModalX";
    };
  }, []);

  return (
    <div className="vi-sales-agent-container">
      <iframe
        src="https://v0-vi-sim-chatbot-shell.vercel.app/"
        title="VI Sales Agent"
        className="vi-sales-agent-iframe"
        style={{ height: iframeHeight }}
        frameBorder="0"
        allow="microphone; camera; clipboard-write; clipboard-read"
        allowFullScreen
      />
    </div>
  );
};

export default VISalesAgent;